import styled from 'styled-components';

export const HallmapWrapper = styled.div`
	position: relative;
	height: calc(100dvh - var(--minus));
  --minus: 151px;
  &#hallmap-modal-container {
    --minus: 90px;
  }
`;
